<template>
  <inner-controlled-accordion-panel
    class="info-report-group"
    :id="`accordion-${getManeuverId(maneuver)}`"
  >
    <div slot="title">
      <b-row
        class="align-items-center"
        v-if="!isDefaultChart"
      >
        <b-col v-if="!isDiagnostics" cols="2" class="adjust-info-columns">
          <div
            class="preview"
            :style="{background: background}"
            v-html="previewContent(
              maneuver.preview.lineTypesBookmark,
              maneuver.preview.lineWidth,
              maneuver.preview.lineSymbols,
              maneuver.preview.lineSymbolColor
            )"
          />
        </b-col>
        <b-col cols="2" class="adjust-info-columns">
          <span> {{ maneuver.name }} </span>
        </b-col>
        <b-col cols="2" class="adjust-info-columns">
          <strong>
            {{ formatDateTime(maneuver.dateTimeOscillography) }}
          </strong>
        </b-col>
        <b-col cols="2" class="adjust-info-columns">
          <strong> {{ maneuver.assetName }} </strong>
        </b-col>
        <b-col cols="2" class="adjust-info-columns">
          <strong> {{ maneuver.installationName }} </strong>
        </b-col>
        <b-col :cols="isDiagnostics ? 2 : 1" class="adjust-info-columns">
          <strong> {{ maneuver.companyName }} </strong>
        </b-col>
         <b-col cols="1" class="adjust-info-columns">
          <strong> {{ maneuver.moduleName.substring(0, 3) }} </strong>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col cols="12">
          <strong> {{ maneuver.name }} </strong>
        </b-col>
      </b-row>
    </div>
    <div class="info-report-group__cards-container w-100">
      <div
        class="mr-2 mb-3"
        v-for="(field, index) in filteredFields"
        :key="index"
      >
        <info-report-card
          :value="field.value"
          :description="field.name"
          :acceptable="field.acceptable"
        />
      </div>
      <s-empty-list v-if="!filteredFields.length" class="w-100" />
    </div>
  </inner-controlled-accordion-panel>
</template>

<script>
import InnerControlledAccordionPanel from '@/components/InnerControlledAccordionPanel';
import { formatter as dateTimeFormatter } from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';
import themeService from '@/services/themeService';
import InfoReportCard from './InfoReportCard';

export default {
  props: {
    maneuver: Object,
    isDefaultChart: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    isDiagnostics: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InnerControlledAccordionPanel,
    InfoReportCard,
  },
  computed: {
    filteredFields() {
      return this.fields.filter(field => field.hasValue);
    },
    background() {
      return themeService.isDarkTheme() ? 'var(--color-background-dark)' : 'var(--color-neutral-background)';
    },
  },
  methods: {
    getManeuverId(maneuver) {
      const maneuverKey = maneuver.maneuverKey || maneuver.maneuverUUID || maneuver.name;
      return maneuverKey.replace(/[^a-zA-Z0-9_-]/g, '_');
    },
    previewContent(typeLine, width, symbol, symbolColor) {
      let typeSymbol = '';

      switch (symbol) {
        case 'circle':
          typeSymbol = `<circle cx="50%" cy="10" r="10" fill="${symbolColor}" />`;
          break;
        case 'rect':
          typeSymbol = `<rect width="14" height="14" x="40%" y="2" style="fill:${symbolColor};stroke-width:3;" />`;
          break;
        case 'triangle':
          typeSymbol = `<polygon points="38,0 45,20 30,20" style="fill:${symbolColor};stroke-width:3" />`;
          break;
        case 'diamond':
          typeSymbol = `<polygon points="38,0 50,10 38,20 26,10" style="fill:${symbolColor};stroke-width:3" />`;
          break;
        default:
          typeSymbol = '';
      }

      return `
        <svg width="100%" height="20">
          <line x1="0" y1="10" x2="100%" y2="10"
            stroke="${themeService.isDarkTheme() ? '#FFF' : '#000'}"
            stroke-width="${!width ? 6 : width}"
            stroke-linejoin="bevel"
            stroke-dasharray="${!typeLine ? '' : typeLine}"
          />${typeSymbol}
        </svg>
      `;
    },
    formatDateTime(dateTime) {
      return dateTimeFormatter(dateTime, formats.DATETIME_SHORT_WITH_SECONDS);
    },
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.info-report-group
  box-shadow: none
  &__cards-container
    margin-right: -22px
    margin-bottom: -14px
    display: flex
    flex-wrap: wrap
    justify-content: center
.preview
    background-color: #ffffff
    width: 85px
    height: 50px
    border: 1px solid $color-border-gray
    padding: 5px
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    & strong
      font-size: 0.8rem
.adjust-info-columns
  word-wrap: break-word
</style>
